{
  "requests.title": "Requests",
  "requests.subtitle": "Everything waiting for your decision: attendance, leave, overtime, expense claims and letters.",
  "requests.tabs.label": "Request views",
  "requests.tabs.inbox": "Waiting for you",
  "requests.tabs.delegations": "While I'm away",
  "requests.nav.waiting": "{count, plural, one {# request waiting} other {# requests waiting}}",

  "requests.group.attendance_request": "Attendance requests",
  "requests.group.leave_request": "Leave",
  "requests.group.overtime": "Overtime",
  "requests.group.expense_claim": "Expense claims",
  "requests.group.letter_request": "HR letters",
  "requests.subject.overtime": "Overtime",
  "requests.subject.expense_claim": "Expense claim",
  "requests.overtime.workday": "workday",
  "requests.overtime.rest_day": "rest day",
  "requests.overtime.holiday": "public holiday",
  "requests.facts.range": "{start} – {end}",

  "requests.inbox.asked": "asked {when}",
  "requests.balance.after": "{days} of {type} left after this request",
  "requests.balance.short": "More than the balance: {days} of {type} short",
  "requests.inbox.approve": "Approve",
  "requests.inbox.reject": "Reject",
  "requests.inbox.approveOne": "Approve {name}'s {label}",
  "requests.inbox.rejectOne": "Reject {name}'s {label}",
  "requests.inbox.selectOne": "Select {name}'s {label}",
  "requests.inbox.selectAll": "Select all",
  "requests.inbox.selected": "{count, plural, one {# selected} other {# selected}}",
  "requests.inbox.approveSelected": "Approve {count, plural, =0 {selected} one {# request} other {# requests}}",
  "requests.inbox.approved": "Approved {name}'s request.",
  "requests.inbox.rejected": "Rejected {name}'s request.",
  "requests.inbox.bulkApproved": "{count, plural, one {# request approved.} other {# requests approved.}}",
  "requests.inbox.bulkPartial": "{count, plural, one {# request approved} other {# requests approved}}; {total} could not be. They stay selected so you can look again.",
  "requests.inbox.loadError": "We could not load your requests.",
  "requests.inbox.empty.title": "Nothing waits for you",
  "requests.inbox.empty.body": "New requests from your team, and those that reach HR, appear here.",

  "requests.bulk.title": "Approve {count, plural, one {# request} other {# requests}}?",
  "requests.bulk.body": "Each request goes to its next step, or is approved if yours was the last one. People are told at once.",
  "requests.reject.title": "Reject {name}'s request?",
  "requests.reject.body": "Say why, so they can ask again with what is missing.",
  "requests.reject.comment": "Comment",
  "requests.reject.confirm": "Reject request",

  "requests.timeline.label": "Approval steps",
  "requests.timeline.show": "Approval steps",
  "requests.timeline.asked": "Asked",
  "requests.timeline.role.manager": "Manager",
  "requests.timeline.role.hr": "HR",
  "requests.timeline.manager": "Their manager",
  "requests.timeline.hrTeam": "The HR team",
  "requests.timeline.state.waiting": "next",
  "requests.timeline.state.current": "deciding now",
  "requests.timeline.state.approved": "approved",
  "requests.timeline.state.rejected": "rejected",
  "requests.timeline.state.skipped": "skipped",

  "requests.delegations.intro": "While you are away, someone you trust decides your team's requests in your place. HR's steps are not delegated.",
  "requests.delegations.add": "Delegate",
  "requests.delegations.addTitle": "Delegate your approvals",
  "requests.delegations.addBody": "They decide the manager step of your team's requests between these dates.",
  "requests.delegations.person": "Who decides for you",
  "requests.delegations.pick": "Choose a colleague",
  "requests.delegations.search": "Search people",
  "requests.delegations.noPeople": "No one matches.",
  "requests.delegations.from": "From",
  "requests.delegations.to": "Until",
  "requests.delegations.save": "Delegate",
  "requests.delegations.added": "Approvals delegated.",
  "requests.delegations.incomplete": "Choose a colleague and both dates.",
  "requests.delegations.endBeforeStart": "The last day must not come before the first.",
  "requests.delegations.active": "Active now",
  "requests.delegations.remove": "Stop delegating to {name}",
  "requests.delegations.removeTitle": "Stop delegating to {name}?",
  "requests.delegations.removeBody": "Your team's requests come back to you from now on.",
  "requests.delegations.removeConfirm": "Stop delegating",
  "requests.delegations.removed": "Delegation removed.",
  "requests.delegations.loadError": "We could not load your delegations.",
  "requests.delegations.empty.title": "No delegations",
  "requests.delegations.empty.body": "Going on leave? Let a colleague decide your team's requests meanwhile.",

  "requests.errors.gone": "This request no longer exists.",
  "requests.errors.closed": "Someone already decided this request, or it was withdrawn.",
  "requests.errors.notYours": "This step is no longer yours to decide.",
  "requests.errors.delegation": "Choose an active colleague other than yourself, and dates in order.",
  "requests.errors.balance": "The leave balance is too low to approve this.",

  "requests.notify.subject.attendance_request": "An attendance request",
  "requests.notify.subject.leave_request": "A leave request",
  "requests.notify.subject.overtime": "An overtime claim",
  "requests.notify.subject.expense_claim": "An expense claim",
  "requests.notify.subject.letter_request": "An HR letter request",
  "requests.notify.yours.attendance_request": "Your attendance request",
  "requests.notify.yours.leave_request": "Your leave request",
  "requests.notify.yours.overtime": "Your overtime claim",
  "requests.notify.yours.expense_claim": "Your expense claim",
  "requests.notify.yours.letter_request": "Your letter request",
  "requests.notify.pending": "{target} from {actor} waits for your decision",
  "requests.notify.decided": "{status, select, approved {{target} was approved} rejected {{target} was rejected} other {{target} was decided}}",
  "requests.notify.alert.contract_ending": "{name}'s contract ends {days, plural, =0 {today} one {in # day} other {in # days}} ({date})",
  "requests.notify.alert.probation_ending": "{name}'s probation ends {days, plural, =0 {today} one {in # day} other {in # days}} ({date})",
  "requests.notify.alert.document_expiring": "{name}'s document {target} expires {days, plural, =0 {today} one {in # day} other {in # days}} ({date})",
  "requests.notify.alert.certification_expiring": "{name}'s certificate {target} expires {days, plural, =0 {today} one {in # day} other {in # days}} ({date})",
  "requests.notify.alert.asset_not_returned": "{name} left {days, plural, one {# day} other {# days}} ago and still has {target}",
  "requests.notify.alert.break_overrun": "{name} went {minutes, plural, other {# min}} over the break allowance on {date}",
  "requests.notify.reviewRequested": "Write your reviews for {target} by {date}",
  "requests.notify.reviewReminder": "Reminder: reviews for {target} are due {date}",
  "requests.notify.reviewPublished": "Your review results for {target} are ready",
  "requests.notify.feedback.praise": "{actor} sent you praise",
  "requests.notify.feedback.private": "{actor} sent you a note",
  "requests.notify.feedback.requested": "{actor} sent you the feedback you asked for",
  "requests.notify.feedbackRequested": "{actor} asks for your feedback on {target}",
  "requests.notify.feedbackRequestedBy": "{actor} asks for your feedback on {target} by {date}",
  "requests.notify.applicationReceived": "{name} applied for {target}",
  "requests.notify.interviewScheduled": "You are on the panel for {name}’s interview ({target}) on {date}",
  "requests.notify.offerAccepted": "{name} accepted the offer for {target}",
  "requests.notify.offerDeclined": "{name} declined the offer for {target}",
  "requests.routes.title": "Who approves what",
  "requests.routes.description": "Each kind of request goes to these people in turn. A kind left on its group's setting follows the group. Requests already open keep their steps.",
  "requests.routes.readOnly": "Each kind of request goes to these people in turn. Only HR managers can change this.",
  "requests.routes.managerOnlyHint": "\"Manager only\" goes to HR when the person has no manager.",
  "requests.routes.caption": "Approval routes",
  "requests.routes.columns.request": "Request",
  "requests.routes.columns.steps": "Approved by",
  "requests.routes.steps.manager_then_hr": "Manager, then HR",
  "requests.routes.steps.hr_only": "HR only",
  "requests.routes.steps.manager_only": "Manager only",
  "requests.routes.inherit": "Same as the group",
  "requests.routes.selectLabel": "Who approves {label}",
  "requests.routes.saved": "Saved who approves {label}.",
  "requests.routes.loadError": "We couldn't load the approval routes."
}
